<!-- 方案加价审核 -->
<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('Pricing.PriceSetting')"
    width="1000px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="fcl-setting-dialog"
  >
    <div class="tabs-container" style="flex:1;overflow:hidden;padding-bottom: 0">
      <el-tabs
        v-if="innerVisible"
        ref="tabs"
        v-model="activeTabName"
        type="card"
        style="width:100%;"
        @tab-click="handleTabClick"
      >
        <el-tab-pane :label="$t('Pricing.Markup')" name="markup">
          <tab-air-approve-settings ref="markup" @close="onCancel" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>

<script>
import TabAirApproveSettings from '@/views/cargo/v0/Price/PriceAir/components/tabAirApproveSettings'
export default {
  name: 'AirSettingsDialog',
  components: { TabAirApproveSettings },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    selectedRows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      rowData: [],
      cfg: {},
      source: null,
      airConfigUtil: null,
      markupSelectRow: null,
      activeTabName: 'markup',
      PFNeedCheckApprove: false
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  watch: {},
  mounted() {
  },
  methods: {
    init(priceAirUtil) {
      this.airConfigUtil = priceAirUtil
      this.PFNeedCheckApprove = priceAirUtil._needCheckApprove
      this.$nextTick(() => {
        this.$refs['markup'].init(this.airConfigUtil)
      })
    },
    onCancel() {
      this.$emit('close')
    },
    // tab 页签点击事件
    handleTabClick(tab, event) {
      console.log(tab, event)
    }
  }
}
</script>

<style scoped>
</style>
